// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";
// Assets
import PlaceHolderImg from "../../../../assets/images/protocols/prescriptions/place_holder.png";

export const GetHandTrackingProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/web/handTracking", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.web.handTracking.MEMOSEQ.id]: {
      img: protocolImg["./memoseq.png"],
      name: "memoseqWeb",
      video: "memoseqWebVideo",
      description: "memoseqWebDescription",
    },
    [protocols.web.handTracking.MIRROR.id]: {
      img: protocolImg["./mirror.png"],
      name: "mirror",
      video: "mirrorVideo",
      description: "mirrorDescription",
    },
    [protocols.web.handTracking.RECYCLING.id]: {
      img: protocolImg["./recycling.png"],
      name: "recycling",
      video: "recyclingVideo",
      description: "recyclingDescription",
    },
    [protocols.web.handTracking.WHAC_A_MOLE.id]: {
      img: protocolImg["./whacAMole.png"],
      name: "whackAMole",
      video: "whackAMoleVideo",
      description: "whackAMoleDescription",
    },
    [protocols.web.handTracking.FULL_BODY.id]: {
      img: PlaceHolderImg,
      name: "Full body",
      video: "",
      description: "",
    },
    [protocols.web.handTracking.BALANCE.id]: {
      img: PlaceHolderImg,
      name: "balance",
      video: "balanceVideo",
      description: "balanceDescription",
    },
    [protocols.web.handTracking.SEQUENCES.id]: {
      img: protocolImg["./sequences.png"],
      name: "sequences",
      video: "sequencesVideo",
      description: "sequencesDescription",
    },
    [protocols.web.handTracking.WORDS.id]: {
      img: protocolImg["./words.png"],
      name: "words",
      video: "wordsVideo",
      description: "wordsDescription",
    },
    [protocols.web.handTracking.OBJECTS_RAIN.id]: {
      img: protocolImg["./objectsRain.png"],
      name: "objectsRain",
      video: "objectsRainVideo",
      description: "objectsRainDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
